import styled from "@emotion/styled";

export const Button = styled.button`
  display: flex;
  border: none;
  align-items: center;
  justify-content: center;
  width: 9.875rem;
  height: 2.25rem;
  background-color: #046af3;
  color: #fff;
  border-radius: 800px;
  :hover {
    cursor: pointer;
    background-color: #023985;
  }
  :disabled {
    background-color: #383838;
    cursor: normal;
  }
`;

export const DropdownDeleteMessage = styled.div`
  display: flex;
  width: calc(100% + 8px);
`;

export const ModalEditMessage = styled.div<{
  isEmojiOpen?: boolean;
  $mainColor?: string;
}>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 45rem;
  height: ${(p) => (p.isEmojiOpen ? "40rem" : "27rem")};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid #e4e4e4;
  border-radius: 12px;
  background-color: #fff;
  padding: 20px 25px;
  z-index: 1000;

  .messages {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }

  .title {
    font-weight: bold;
    font-size: 16px;
  }

  .originalMessage {
    display: flex;
    flex-direction: column;
    background: #f0eff5;
    border-radius: 4px;
    padding: 5px 10px;
    height: 110px;
    overflow: hidden;
  }

  .originalTitle {
    font-weight: bold;
  }

  .originalText {
    flex: 1;
    min-height: 0;
    overflow: auto;
    white-space: pre-wrap;

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border-radius: 4px;
    }
  }

  .newMessage {
    font-size: 16px;
    margin-top: 10px;
  }

  .editedMessage {
    position: relative;
    width: 100%;
  }

  .tooltip-Smile {
    position: absolute;
    right: 8px;
    bottom: 8px;
    padding-bottom: 5px;
    z-index: 2;
  }

  .editedText {
    width: 100%;
    height: 110px;
    border-radius: 4px;
    padding: 5px 10px;
    border: 1px solid #e4e4e4;
    outline: none;
    white-space: pre-wrap;
    overflow: auto;
    resize: none;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    position: relative;

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border-radius: 4px;
    }
  }

  .buttons {
    display: flex;
    justify-content: center;
    width: 100%;
    gap: 1rem;
  }

  button {
    font-weight: bold;
    border-radius: 8px;
  }

  .cancel {
    width: 10rem;
    background-color: #fff;
    border: 1px solid #c4ccd8;
    color: #000;
  }

  .cancel:hover,
  .cancel:enabled:hover,
  .cancel:focus,
  .cancel:active {
    background-color: #fff;
    border: 1px solid #c4ccd8;
    color: #000;
    box-shadow: none;
  }

  .confirm {
    width: 10rem;
    background-color: #fff;
    border: 1px solid ${({ $mainColor }) => $mainColor || "#2624CD"};
    color: ${({ $mainColor }) => $mainColor || "#2624CD"};
  }
`;

export const ForwardMessageModal = styled.div<{ $mainColor?: string }>`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  width: min(468px, calc(100vw - 32px));
  height: min(678px, calc(100vh - 32px));
  max-height: calc(100vh - 32px);
  padding: 0 20px 20px 20px;
  background: #fff;
  border: 1px solid #e4e8ef;
  border-radius: 0 56px 0 0;
  box-shadow: 0 18px 50px rgba(17, 24, 39, 0.12);

  .closeButton {
    position: absolute;
    top: 23px;
    right: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    padding: 0;
    background: #fff;
    color: ${({ $mainColor }) => $mainColor || "#2624CD"};
    border: 1px solid ${({ $mainColor }) => $mainColor || "#2624CD"};
    border-radius: 50%;
    cursor: pointer;

    .pi {
      font-size: 11px;
      line-height: 1;
    }
  }

  .header {
    display: flex;
    align-items: center;
    gap: 18px;
    padding: 0 5px;
    margin: 62px 0 24px;
    flex-shrink: 0;
  }

  .botIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 42px;
    flex-shrink: 0;

    img {
      max-width: 58px;
      max-height: 42px;
      object-fit: contain;
    }
  }

  .title {
    color: #07083f;
    font-size: 15px;
    font-weight: 700;
  }

  .search {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 32px;
    padding: 0 10px;
    border: 1px solid #dce3ed;
    border-radius: 8px;
    color: #8b95a7;
    flex-shrink: 0;

    input {
      width: 100%;
      min-width: 0;
      border: none;
      outline: none;
      color: #595175;
      font: inherit;

      &::placeholder {
        color: #595175;
      }
    }
  }

  .contacts {
    flex: 1;
    height: 0;
    min-height: 0;
    margin-top: 16px;
    padding: 10px 10px 14px;
    border: 1px solid #e1e6ee;
    border-radius: 8px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 8px;
      background-color: transparent;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border-radius: 4px;
    }
  }

  .contact {
    display: grid;
    grid-template-columns: 28px 48px minmax(0, 1fr);
    align-items: center;
    gap: 10px;
    min-height: 66px;
    cursor: pointer;
  }

  .avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    color: #fff;
    background: ${({ $mainColor }) => $mainColor || "#2624CD"};
    border: 2px solid #fff;
    border-radius: 50%;
    box-shadow: 0 0 0 1px ${({ $mainColor }) => $mainColor || "#2624CD"};
    font-size: 18px;
    font-weight: 500;
  }

  .contactInfo {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .name {
    color: #121212;
    font-size: 15px;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .phone {
    color: ${({ $mainColor }) => $mainColor || "#2624CD"};
    font-size: 15px;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  .empty {
    padding: 26px 4px;
    color: #667085;
    text-align: center;
  }

  .forwardButton {
    align-self: center;
    width: 138px;
    height: 32px;
    margin-top: 36px;
    flex-shrink: 0;
    background: ${({ $mainColor }) => $mainColor || "#2624CD"};
    border-color: ${({ $mainColor }) => $mainColor || "#2624CD"};
    border-radius: 8px;
    font-size: 13px;
    font-weight: 700;

    &:enabled:hover,
    &:enabled:focus,
    &:enabled:active {
      background: ${({ $mainColor }) => $mainColor || "#2624CD"};
      border-color: ${({ $mainColor }) => $mainColor || "#2624CD"};
      box-shadow: none;
    }
  }

  @media screen and (max-width: 599px) {
    height: min(678px, calc(100vh - 32px));
    padding: 24px 18px 20px;
    border-radius: 0 48px 0 0;

    .header {
      margin-top: 62px;
    }
  }
`;

export const ImgIcon = styled.button`
  border: none;
  background-color: transparent;

  :hover {
    cursor: pointer;
  }

  :disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const QuoteMessage = styled.div<{
  $kind: "text" | "image" | "audio" | "video" | "other";
}>`
  display: flex;
  flex-direction: row;
  width: 100%;
  background: #f0eff5;
  margin: 5px 0 15px 0;
  min-height: ${({ $kind }) =>
    $kind === "image"
      ? "100px"
      : $kind === "video"
      ? "220px"
      : $kind === "audio"
      ? "80px"
      : "60px"};
  height: auto;

  border-radius: 14px;

  .blueLine {
    width: 10px;
    flex: 0 0 10px;
    background-color: #2624cd;
    margin-right: 8px;
    border-radius: 14px 0 0 14px;
  }

  .message {
    display: flex;
    flex-direction: column;
    padding: 2px 0;
    width: 100%;
  }

  .name {
    color: #2624cd;
    height: 40%;
  }

  .text {
    width: 100%;
    text-align: initial;

    height: ${({ $kind }) =>
      $kind === "image"
        ? "150px"
        : $kind === "video"
        ? "auto"
        : $kind === "audio"
        ? "250px"
        : "60%"};

    ${({ $kind }) =>
      $kind === "text"
        ? `
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        line-height: 18px;
        max-height: 18px;
      `
        : `
        max-height: none;
        overflow: visible;
        text-overflow: unset;
        display: block;
        -webkit-line-clamp: unset;
        -webkit-box-orient: unset;
      `}
  }

  .divButton {
    display: flex;
    align-items: center;
  }
`;

export const CannedMessageAutocomplete = styled.div`
  position: absolute;
  left: 84px;
  right: 164px;
  bottom: calc(100% + 12px);
  height: 253px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #dbe3f0;
  border-radius: 14px 14px 6px 14px;
  box-shadow: 0 8px 24px rgba(15, 23, 43, 0.12);
  overflow: hidden;
  z-index: 15;

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid #edf2f7;
  }

  .headerLeft {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    color: #62748e;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }

  .headerLeft img {
    width: 14px;
    height: 14px;
    object-fit: contain;
  }

  .manageButton {
    border: none;
    background: transparent;
    color: #4b5565;
    font-family: "Poppins";
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    cursor: pointer;
    padding: 0;
  }

  .manageButton:hover {
    color: #1f2937;
  }

  .suggestionsList {
    display: flex;
    flex-direction: column;
    max-height: 228px;
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar {
      width: 8px;
      background-color: transparent;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border-radius: 4px;
    }
  }

  .emptyState {
    min-height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 16px;
    color: #62748e;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
  }
`;

export const CannedMessageAutocompleteItem = styled.button`
  width: 100%;
  border: none;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 2px;
  padding: 12px 16px;
  cursor: pointer;
  text-align: left;
  border-top: 1px solid #edf2f7;

  &:first-of-type {
    border-top: none;
  }

  &.selected {
    background: #f5f5f5;
  }

  .topLine {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    min-width: 0;
  }

  .shortcut {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    min-height: 24px;
    padding: 0 10px;
    border-radius: 999px;
    background: #eef2f6;
    color: #101828;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    flex-shrink: 0;
  }

  .title {
    min-width: 0;
    color: #101828;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .message {
    width: 100%;
    color: #62748e;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ComposerAttachmentsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  margin: 5px 0 15px 0;
`;

export const ComposerAttachmentCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: min(100%, 320px);
  min-height: 72px;
  padding: 10px 12px;
  border-radius: 14px;
  background: #f0eff5;
`;

export const ComposerAttachmentPreview = styled.div`
  position: relative;
  flex: 0 0 64px;
  width: 64px;
  height: 64px;
  border-radius: 10px;
  overflow: hidden;
  background: #dde2eb;
  display: flex;
  align-items: center;
  justify-content: center;

  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  audio {
    width: 100%;
    height: 36px;
  }
`;

export const ComposerAttachmentUploadOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(17, 24, 39, 0.55);
`;

export const ComposerAttachmentFallback = styled.span`
  color: #4b5565;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
`;

export const ComposerAttachmentInfo = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
  padding-top: 2px;
`;

export const ComposerAttachmentKindLabel = styled.div<{ $mainColor?: string }>`
  color: ${({ $mainColor }) => $mainColor || "#2624CD"};
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
`;

export const ComposerAttachmentName = styled.div`
  color: #111827;
  font-size: 13px;
  line-height: 18px;
  word-break: break-word;
`;

export const ComposerAttachmentRemoveButton = styled.button<{
  $mainColor?: string;
}>`
  border: none;
  background: transparent;
  height: 100%;
  color: ${({ $mainColor }) => $mainColor || "#2624CD"};
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  padding: 2px 0 0 0;

  :disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const OmnichannelDropOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 43, 0.16);
  backdrop-filter: blur(2px);
`;

export const OmnichannelDropOverlayCard = styled.div<{ $mainColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: min(90vw, 420px);
  min-height: 180px;
  padding: 24px 32px;
  border: 2px dashed ${({ $mainColor }) => $mainColor || "#2624CD"};
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.96);
  color: ${({ $mainColor }) => $mainColor || "#2624CD"};
  font-family: "Poppins";
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  text-align: center;
  box-shadow: 0 16px 40px rgba(15, 23, 43, 0.12);
`;

export const ParentId = styled.div<{
  $variant: "agent" | "client";
  $kind: "text" | "image" | "audio" | "video" | "other";
}>`
  padding: 8px 8px;
  border-radius: 8px;
  margin-bottom: 6px;
  margin-top: 6px;

  background: ${({ $variant }) =>
    $variant === "agent" ? "#d8d7e0" : "#1470C7"};

  color: ${({ $variant }) => ($variant === "agent" ? "#212529" : "#fff")};

  height: ${({ $kind }) =>
    $kind === "image"
      ? "220px"
      : $kind === "video"
      ? "auto"
      : $kind === "audio"
      ? "100%"
      : "auto"};
`;

export const ImageViewerOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(6, 10, 18, 0.94);
  padding: 24px 88px 132px;

  @media screen and (max-width: 768px) {
    padding: 16px 56px 120px;
  }
`;

export const ImageViewerStage = styled.div<{ $isDraggable: boolean }>`
  width: min(100%, calc(100vw - 208px));
  height: min(100%, calc(100vh - 224px));
  max-width: 1680px;
  max-height: calc(100vh - 224px);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: ${({ $isDraggable }) => ($isDraggable ? "grab" : "default")};
  touch-action: none;
  overscroll-behavior: contain;

  @media screen and (max-width: 768px) {
    width: min(100%, calc(100vw - 112px));
    height: min(100%, calc(100vh - 208px));
    max-height: calc(100vh - 208px);
  }
`;

export const ImageViewerPanSurface = styled.div<{ $x: number; $y: number }>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(${({ $x }) => $x}px, ${({ $y }) => $y}px);
  will-change: transform;
`;

export const ImageViewerMainImage = styled.img<{
  $zoom: number;
  $originX: number;
  $originY: number;
  $isDragging: boolean;
}>`
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transform: scale(${({ $zoom }) => $zoom});
  transform-origin: ${({ $originX, $originY }) => `${$originX}% ${$originY}%`};
  transition: transform 0.15s ease;
  user-select: none;
  cursor: ${({ $zoom, $isDragging }) =>
    $zoom > 1 ? ($isDragging ? "grabbing" : "grab") : "default"};
`;

export const ImageViewerActionStack = styled.div`
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 1201;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media screen and (max-width: 768px) {
    top: 16px;
    right: 16px;
    gap: 10px;
  }
`;

export const ImageViewerIconButton = styled.button<{
  $variant: "close" | "left" | "right" | "zoom";
}>`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 999px;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(6px);
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;

  ${({ $variant }) =>
    $variant === "close"
      ? `
        position: static;
        width: 56px;
        height: 56px;
        font-size: 32px;
      `
      : $variant === "zoom"
      ? `
        position: static;
        width: 56px;
        height: 56px;
        font-size: 24px;
      `
      : `
        top: 50%;
        transform: translateY(-50%);
        width: 56px;
        height: 56px;
        font-size: 44px;
      `}

  ${({ $variant }) => ($variant === "left" ? "left: 24px;" : "")}
  ${({ $variant }) => ($variant === "right" ? "right: 24px;" : "")}

  &:hover {
    background: rgba(255, 255, 255, 0.18);
  }

  @media screen and (max-width: 768px) {
    ${({ $variant }) =>
      $variant === "close"
        ? `
          position: static;
          width: 48px;
          height: 48px;
          font-size: 28px;
        `
        : $variant === "zoom"
        ? `
          width: 48px;
          height: 48px;
          font-size: 22px;
        `
        : `
          width: 48px;
          height: 48px;
          font-size: 34px;
        `}

    ${({ $variant }) => ($variant === "left" ? "left: 8px;" : "")}
    ${({ $variant }) => ($variant === "right" ? "right: 8px;" : "")}
  }
`;

export const ImageViewerThumbRail = styled.div`
  position: fixed;
  left: 50%;
  bottom: 24px;
  transform: translateX(-50%);
  z-index: 1201;
  width: min(92vw, 1540px);
  background: rgba(0, 0, 0, 0.88);
  padding: 20px 72px;
  overflow: hidden;

  @media screen and (max-width: 768px) {
    bottom: 16px;
    padding: 16px 56px;
  }
`;

export const ImageViewerThumbList = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  overflow-x: auto;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.28);
    border-radius: 999px;
  }
`;

export const ImageViewerThumbButton = styled.button<{ $active: boolean }>`
  width: 110px;
  height: 76px;
  padding: 0;
  flex: 0 0 auto;
  border: 2px solid
    ${({ $active }) => ($active ? "#ffffff" : "rgba(255, 255, 255, 0.16)")};
  background: transparent;
  opacity: ${({ $active }) => ($active ? 1 : 0.65)};
  cursor: pointer;
  overflow: hidden;
  transition: opacity 0.2s ease, border-color 0.2s ease, transform 0.2s ease;

  &:hover {
    opacity: 1;
    transform: translateY(-1px);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  @media screen and (max-width: 768px) {
    width: 84px;
    height: 60px;
  }
`;

export const ContainerLeftModal = styled.div`
  width: 59%;
  position: relative;
  height: 100%;
  top: 0px;
  content: none;
  background-color: white;
  padding: 0 1rem 1rem 1rem;
`;

export const ContainerRightModal = styled.div`
  width: 41%;
  position: relative;
  height: 100%;
  top: 0px;
  content: none;
  padding: 1rem;
  display: flex;
  align-items: start;
  justify-content: space-between;
`;

export const CannedMessageRightModalContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: start;
  justify-content: center;
  color: #fff;
  padding: 0 1rem;

  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 1.5rem;
  }

  .iconWrapper {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .icon {
    width: 124px;
    height: 124px;
    object-fit: contain;
  }

  .textGroup {
    display: flex;
    flex-direction: column;
    gap: 0.875rem;
  }

  .title {
    font-size: 14px;
    line-height: 1.15;
    font-weight: 700;
  }

  .description {
    font-size: 12px;
    line-height: 1.75;
    color: rgba(248, 250, 252, 0.8);
  }
`;
